import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import UserPermissionRow from './UserPermissionRow';

const UserPermissionTable = ({
  onTogglePermission,
  permissionTable,
  supportsCareSheet
}) => {
  const subscriptionPermissions = permissionTable.map((subscription) => {
    return <UserPermissionRow key={subscription.id} subscription={subscription} onTogglePermission={onTogglePermission} supportsCareSheet={supportsCareSheet} />;
  });

  return (
    <div className="row">
      <div className="col-lg-12">
        <h5 className="permissions-title">{I18n.t('PERMISSIONS')}</h5>
        <table className="table permissions-table table-responsive">
          <thead>
            <tr>
              <th>{I18n.t('LOCATION')}</th>
              {supportsCareSheet && <th>{I18n.t('PRINT_CARE_SHEETS')}</th>}
              <th>{I18n.t('PRINT_LABELS')}</th>
              {supportsCareSheet &&  <th>{I18n.t('EDIT_AD_SPACE')}</th> }
              {supportsCareSheet && <th>{I18n.t('EDIT_STORE_INFO_LOGO')}</th>}
              <th>{I18n.t('ARTICLE_MANAGEMENT')}</th>
            </tr>
          </thead>
          <tbody>
            {subscriptionPermissions}
          </tbody>
        </table>
      </div>
    </div>
  );
};

UserPermissionTable.propTypes = {
  onTogglePermission: PropTypes.func.isRequired,
  permissionTable: PropTypes.array.isRequired,
  supportsCareSheet: PropTypes.bool.isRequired
};

export default UserPermissionTable;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UserPermissionTable.js
 **/